import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
  T_SsoSliceState,
  T_ValidateSSOOldRes,
  TriggerGenerateSSO_OLD,
} from "./Sso_Types";

const initialState: T_SsoSliceState<
  T_ValidateSSOOldRes | TriggerGenerateSSO_OLD
> = {
  ssoData: {},
  triggerId: "",
};

export const SsoSlice = createSlice({
  name: "SsoSlice",
  initialState: initialState,
  reducers: {
    clearSsoSlice: (state) => {
      return { ssoData: {} };
    },
    clearSsoSliceWithTriggerId: (state, action: PayloadAction<string>) => {
      return { ssoData: {}, triggerId: action.payload || "" };
    },
    updateSSOSlice: (state, action: PayloadAction<T_ValidateSSOOldRes>) => {
      return { ...state, ssoData: action.payload };
    },
    triggerGenerateSSOOld: (
      state,
      action: PayloadAction<TriggerGenerateSSO_OLD>,
    ) => {
      return {
        ssoData: action.payload,
      };
    },
    disableShowLoading: (state) => {
      return { ssoData: { ...state.ssoData, showLoading: false } };
    },
  },
});

export const SsoSliceReducer = SsoSlice.reducer;
export const SsoSliceKey = SsoSlice.reducerPath;
export const {
  updateSSOSlice,
  triggerGenerateSSOOld,
  clearSsoSlice,
  clearSsoSliceWithTriggerId,
  disableShowLoading,
} = SsoSlice.actions;
